module.exports = __webpack_public_path__ + "static/media/mini.78fd23ef.png";